import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeading = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M3.75 1.75h2m0 0h2m-2 0V10m0 0v8.25m0-8.25h9m-9 8.25h-2m2 0h2m5-16.5h2m0 0h2m-2 0V10m0 0v8.25m0 0h-2m2 0h2"
	})]
});
const ForwardRef = forwardRef(SvgHeading);
export { ForwardRef as ReactComponent };
